import angular from "angular";
import template from "./admin-schools.html";
import AdminSchoolsController from "./admin-schools.controller";
import View from "./view/admin-school-view.module";
import Edit from "./edit/admin-edit-school.module";
import Vehicles from "./vehicles/admin-school-vehicles.module";
import Zones from "./zones/school-zones.module";
import Billing from "./billing/billing.module";
import UpdatePaymentMethod from "./update-payment-method/update-payment-method.module";
import PurchaseOnlineDriversEd from "./purchase-online-drivers-ed/purchase-online-drivers-ed.module";

const modules = [
  View.name,
  Edit.name,
  Vehicles.name,
  Zones.name,
  Billing.name,
  UpdatePaymentMethod.name,
  PurchaseOnlineDriversEd.name,
];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.schools", {
    url: "/schools",
    abstract: true,
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.schools", modules)
  .config(config)
  .controller("AdminSchoolsController", AdminSchoolsController);
